import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/navigation'
import AnimatedLogo from '@/components/effects/AnimatedLogo'

const SIZE = 128

// Sits in normal document flow above the hero — not sticky, just the first
// thing on the page — and scrolls away with the rest of the content.
// Below ~600px (four languages) the fixed language pill (top-right) would overlap the logo, so
// the logo starts lower there and clears it.
export default function SiteLogo() {
  const t = useTranslations('nav')

  return (
    <div
      className="relative z-[60] flex justify-center pt-4 pb-4 max-[600px]:pt-20"
    >
      <Link prefetch={false} href="/" aria-label={t('homeLabel')}>
        <AnimatedLogo size={SIZE} />
      </Link>
    </div>
  )
}
